import React from 'react'
import {FAQ} from 'Event/FAQs'
import Card from 'lib/ui/Card'
import Box from '@material-ui/core/Box'
import CardHeader from 'lib/ui/Card/CardHeader'
import CardContent from 'lib/ui/Card/CardContent'
import Collapse from '@material-ui/core/Collapse'
import {useAttendeeVariables} from 'Event'
import Content from 'lib/ui/form/TextEditor/Content'
import FaqConfig from 'Event/FAQs/FAQConfig'
import Configurable from 'organization/Event/Configurable'
import {useCardsTemplate} from 'Event/template/Cards'
import styled from 'styled-components'

type BodyProps = {
  faq: FAQ
  className?: string
  id: string
  answerVisible?: boolean
}

export default function Body(props: BodyProps) {
  return (
    <Configurable>
      <FaqConfig faq={props.faq} id={props.id} />
      <FaqCard {...props} />
    </Configurable>
  )
}

function FaqCard(props: BodyProps) {
  const {faq, answerVisible} = props
  const template = useCardsTemplate()
  const {linkColor, linkUnderline} = template
  const startExpanded =
    Boolean(props.answerVisible) || Boolean(faq.showAnswerOnLoad)

  const [expanded, setExpanded] = React.useState(startExpanded)
  const v = useAttendeeVariables()

  const handleExpandClick = () => {
    if (answerVisible) {
      return
    }

    setExpanded(!expanded)
  }

  return (
    <CardContainer
      onClick={() => {
        handleExpandClick()
      }}
      linkColor={linkColor}
      linkUnderline={linkUnderline}
    >
      <Card>
        <CardHeader title={v(faq.question)} />
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Content>{v(faq.answer)}</Content>
          </CardContent>
        </Collapse>
      </Card>
    </CardContainer>
  )
}

const CardContainer = styled(Box)<{
  linkColor: string
  linkUnderline: boolean
}>`
  a {
    color: ${(props) => props.linkColor};
    text-decoration: none;

    &:hover {
      text-decoration: ${(props) =>
        props.linkUnderline ? 'underline' : 'none'};
    }
  }
`
